import React, { Fragment, useEffect, useState } from "react";
import Skeleton from "../shared/skeleton";
import Form from "../_lib/form/form";
import { helper, http, notify } from "../../util";
import { useHistory, useParams } from "react-router";
import CustomButton from "../shared/button";
import { useSelector } from "react-redux";
import { getAll } from "../../actions/a.ruletext";
import PopupModal from "../PopupModal/PopupModal";
import { useDispatch } from "react-redux";

const InvoiceForm = () => {
    const [ConfirmationError, setConfirmationError] = useState(false);
    const [invalidInput, setInvalidInput] = useState(null);
    const { arg2 } = useParams();
    const history = useHistory();
    const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

    const { userTypes } = useSelector((store) => store.Invoice);
    const { item } = useSelector((store) => store.RuleText);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAll());
    }, []);

    const getFormRows = () => {
        let rows = [],
            userTypesList = helper.format4ReactSelect(userTypes, 'Value', 'Title'),
            cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "radio-list",
                    name: "userType",
                    label: "نوع کاربر",
                    defaultValue: 1,
                    items: userTypesList
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "name",
                    label: "نام و نام خانوادگی",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required" },
                    dependOn: { name: 'userType', value: '1' }
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "nationalCode",
                    defaultValue: "",
                    label: "کد ملی",
                    required: true,
                    attr: { "data-checkify": "required,number" },
                    dependOn: { name: 'userType', value: '1' }
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "companyName",
                    label: "نام شرکت",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required" },
                    dependOn: { name: 'userType', value: '2' }
                }
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "NationalID",
                    defaultValue: "",
                    label: "شناسه ملی",
                    attr: { "data-checkify": "required,number" },
                    dependOn: { name: 'userType', value: '2' }
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "address",
                    defaultValue: "",
                    label: "آدرس",
                    required: true,
                    attr: { "data-checkify": "required" },
                    dependOn: { name: 'userType', value: '1,2' }
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "postalCode",
                    defaultValue: "",
                    label: "کد پستی",
                    required: true,
                    attr: { "maxlength": "10", "data-checkify": "required,number" },
                    dependOn: { name: 'userType', value: '1,2' }
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "mobile",
                    label: "شماره موبایل ",
                    defaultValue: "",
                    required: true,
                    attr: { "maxlength": "11", "data-checkify": "required,number" },
                    dependOn: { name: 'userType', value: '1' }
                }
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "PhoneNumber",
                    label: "شماره تماس",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required,number" },
                    dependOn: { name: 'userType', value: '2' }
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "checkbox",
                    name: "Confirmation",
                    defaultValue: false,
                    label: (
                        <span style={{lineHeight: "1.5"}}>
                            پیش فاکتور به لحاظ مالی و فنی مورد تایید است. برای دیدن متن قوانین <span onClick={() => setIsModalOpen(true)} style={{ cursor: "pointer", color: "skyblue" }}>کلیک کنید.</span>
                        </span>
                    ),
                    attr: { "data-checkify": "required" },
                    dependOn: { name: 'userType', value: '1,2' }
                },
            ],
        });

        rows.push({ cols });

        return rows;
    };

    const { isFetching } = useSelector((state) => state.Invoice);

    const handleSubmit = async (data, afterSubmit) => {
        const dataObj = JSON.parse(await data.get("Data").text());

        const { NationalCode, NationalID, Confirmation } = dataObj;

        console.log(dataObj);

        if (!NationalCode?.length > 0 && !NationalID?.length > 0) {
            setInvalidInput(
                "پر کردن یکی از دو فیلد کدملی و شناسه ملی الزامی است."
            );
            afterSubmit();
            return;
        }

        if (!NationalID || NationalID?.length === 0) {
            if (!helper.ValidateNationalCode(NationalCode)) {
                setInvalidInput("کدملی وارد شده صحیح نمیباشد.")
                afterSubmit();
                return
            }
        }

        if (!Confirmation) {
            setInvalidInput("برای ادامه پرداخت تایید پیش فاکتور الزامی است.")
            afterSubmit();
            return
        }

        setInvalidInput(null)

        http.post(helper.getApiPath("invoice", "UpdateCustomerInfo"), {
            ...dataObj,
            ID: arg2.split("-")[1],
        }).then((res) => {
            afterSubmit();
            proceedPayment(res);
        });
    };

    const proceedPayment = (res) => {
        if (!res.status) {
            postRefId(res.RefID);
        }
    };

    const postRefId = (refIdValue) => {
        var form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', 'https://bpm.shaparak.ir/pgwchannel/startpay.mellat');
        form.setAttribute('target', '_self');
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('name', 'RefId');
        hiddenField.setAttribute('value', refIdValue);
        form.appendChild(hiddenField);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    if (isFetching)
        return (
            <Skeleton
                align="center"
                width={40}
                schema={skeletonSchema}
                animation="blink"
            />
        );

    return (
        <div className="invoice__form">
            <CustomButton
                className="invoice__returnToList"
                func={(e) => {
                    e.preventDefault();
                    history.goBack();
                }}
                children={
                    <p>
                        بازگشت
                        <i className="fa fa-angle-double-left"></i>
                    </p>
                }
            />
            <h4>برای ادامه روند پرداخت فرم زیر را کامل کنید</h4>

            <Form
                rows={getFormRows()}
                onSubmit={handleSubmit}
                onInvalid={() => { }}
                submitButtonText="پرداخت"
            />
            {ConfirmationError && (
                <h5 className="invoice__confirmationError">
                    برای ادامه پرداخت تایید پیش فاکتور الزامی است.
                </h5>
            )}
            {invalidInput && (
                <h5 className="invoice__confirmationError">
                    {invalidInput}
                </h5>
            )}

            {/* Render the modal */}
            <PopupModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                content={item}
            />
        </div>
    );
};

const skeletonSchema = [[[100, 40]], [[100, 215]], [[100, 30]], [[100, 30]]];

export default InvoiceForm;